import { AUTO, DEFAULT_CONNECTION_BACKGROUND } from '../constants.js';
import { deepExtend } from '../utils/deep-extend.js';

const defaultOptions = {
    width: 7,
    height: 7,
    fill: {
        color: DEFAULT_CONNECTION_BACKGROUND
    },
    hover: {}
};
class Connector {
    constructor(shape, options) {
        this.options = deepExtend({}, defaultOptions, options);
        this.connections = [];
        this.shape = shape;
    }
    position() {
        if (this.options.position) {
            return this.options.position(this.shape);
        }
        else {
            return this.shape.getPosition(this.options.name);
        }
    }
    toJSON() {
        return {
            shapeId: this.shape.toString(),
            connector: this.options.name
        };
    }
    static parse(diagram, str) {
        const tempStr = str.split(':'), id = tempStr[0], name = tempStr[1] || AUTO;
        for (let i = 0; i < diagram.shapes.length; i++) {
            const shape = diagram.shapes[i];
            if (shape.options.id === id) {
                return shape.getConnector(name.trim());
            }
        }
    }
    ;
}

export { Connector };
